import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFieldDecimalPlacesConfig } from 'hooks';
import { set } from '@totalsoft/change-tracking-react';
import { Grid, TableCell, TableRow } from '@mui/material';
import { TextField, Autocomplete, IconButton } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { ADMIN_TAX_RATES_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';

const TaxRateItem = ({ taxRate, taxRateLens, readOnly, onSave, onEdit, onCancel, onDelete, validation }) => {
  const [t] = useTranslation();
  const { cvsChPercent } = useFieldDecimalPlacesConfig();
  const canWrite = usePermission(ADMIN_TAX_RATES_WRITE);

  const categoryOptions = [
    { category: 0, name: t('TaxRate.WithoutDeduction') },
    { category: 1, name: t('TaxRate.WithDeduction') }
  ];

  return (
    <TableRow>
      <TableCell>
        <TextField
          fullWidth
          onChange={taxRateLens.description |> set}
          value={taxRate.description}
          disabled={readOnly}
          error={!isValid(validation.description)}
          helperText={getErrors(validation.description)}
        />
      </TableCell>
      <TableCell>
        <TextField
          fullWidth
          onChange={taxRateLens.code |> set}
          value={taxRate.code}
          disabled={readOnly}
          error={!isValid(validation.code)}
          helperText={getErrors(validation.code)}
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          fullWidth
          disabled={readOnly}
          simpleValue={true}
          valueKey='category'
          value={taxRate.category}
          options={categoryOptions}
          onChange={taxRateLens.category |> set}
        />
      </TableCell>
      <TableCell>
        <TextField
          isNumeric
          value={taxRate?.percent}
          onChange={taxRateLens.percent |> set}
          decimalScale={cvsChPercent}
          disabled={readOnly}
          error={!isValid(validation.percent)}
          helperText={getErrors(validation.percent)}
        />
      </TableCell>
      <TableCell>
        {readOnly ? (
          <Grid container justifyContent={'end'}>
            <Grid>
              <IconButton type='edit' tooltip={t('Edit')} color='transparent' size='small' onClick={onEdit} disabled={!canWrite} />
            </Grid>
            <Grid>
              <IconButton type='delete' tooltip={t('Delete')} color='transparent' size='small' onClick={onDelete} disabled={!canWrite} />
            </Grid>
          </Grid>
        ) : (
          <Grid container justifyContent={'end'}>
            <Grid>
              <IconButton type='cancel' tooltip={t('Cancel')} color={'transparent'} size='small' onClick={onCancel} />
            </Grid>
            <Grid>
              <IconButton
                type='save'
                tooltip={t('Save')}
                color={'transparent'}
                size='small'
                onClick={onSave}
                disabled={!isValid(validation)}
              />
            </Grid>
          </Grid>
        )}
      </TableCell>
    </TableRow>
  );
};

TaxRateItem.propTypes = {
  taxRate: PropTypes.object.isRequired,
  taxRateLens: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default TaxRateItem;
